import { AnyAction } from 'redux';
import { reducerWrapper } from '../support/utils';
import { FETCH_LINK_CREATION_BLOCKED_STATUS } from '../actions/FraudFighterActions';

export type FraudFighterReducer = {
  loading: boolean;
  error: any;
  isLinkCreationBlocked: boolean | null;
};

export const INIT_STATE: FraudFighterReducer = {
  loading: true,
  error: null,
  isLinkCreationBlocked: null,
};

const Handler = (state: FraudFighterReducer, action: AnyAction): FraudFighterReducer => {
  switch (action.type) {
    case FETCH_LINK_CREATION_BLOCKED_STATUS.response:
      return {
        ...state,
        loading: false,
        isLinkCreationBlocked: action.data.is_link_creation_blocked,
      };

    default:
      return state;
  }
};

const FraudFighter = reducerWrapper<FraudFighterReducer, AnyAction>(INIT_STATE, Handler, {
  request: [],
  error: [],
});

export default FraudFighter;
